module.exports = __webpack_public_path__ + "static/media/popup-box-preview.058106f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/TestimonialsLegacy/images/popup-box-preview.png
// module id = 5997
// module chunks = 13